import React from "react";
import { Outlet } from "react-router-dom";

function CustomerLayout() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default CustomerLayout;
